import React from 'react'
import { Tooltip } from 'react-tooltip'

// port of cowebapp analytics/helpers/heading.js (react-tooltip v3 → v5)
const Heading = ({ title, toolTipMessage }) => {
  return (
    <div>
      <div className="page-report-sub-heading">
        {title}
        <span
          className="help-tip-report ms-2"
          data-tooltip-id="reason-help-text"
        />
        <Tooltip
          className="custom-header-tooltip"
          id="reason-help-text"
          place="bottom"
        >
          {toolTipMessage}
        </Tooltip>
      </div>
    </div>
  )
}

export default Heading
